import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import AddButton, {AddButtonAbove} from '../fw/AddButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonList.title', 'defaultMessage': 'List of Addons'}
});

interface ChannelAddonListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class ChannelAddonList extends React.Component<ChannelAddonListProps> {

    typeName = 'channelAddons';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const {channelAddons} = this.props.user.organisation.channel;
        const {channel} = this.props.user.organisation;
        let list = channelAddons;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                    <AddButtonAbove list={list.edges} metadata={type} parent={channel} urlMapping={urlMapping} />

                    <PagingGrid
                        columns={['name', 'addonDef.name', 'sourceDef.name']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping}
                    />

                    <AddButton metadata={type} organisationId={this.props.user.organisation.realId} parent={channel} urlMapping={urlMapping} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonList), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name
                        },
                        organisation_id,
                        channelAddons (first: $first, after: $after, before: $before, last: $last) {
                            edges {
                                node {
                                    id,
                                    name,
                                    channelDef_id,
                                    organisation_id,
                                    channel_id,
                                    sourceDef_id,
                                    sourceDef {
                                        id,
                                        name
                                    },
                                    addonDef {
                                        id,
                                        name,
                                        channelDef {
                                            id,
                                            name,
                                            icon
                                        }
                                    }
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        }
                    }
                }
            }
        `,
    },
});
